webpackJsonp([0],{

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n'], ['\n  text-align: center;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(133);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _hero = __webpack_require__(431);

var _hero2 = _interopRequireDefault(_hero);

var _intro = __webpack_require__(439);

var _intro2 = _interopRequireDefault(_intro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

exports.default = function () {
  return _react2.default.createElement(
    Container,
    null,
    _react2.default.createElement(_hero2.default, null),
    _react2.default.createElement(_intro2.default, null)
  );
};

var Container = _styledComponents2.default.div(_templateObject);

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = __webpack_require__(424);

var _default = _grid.Row;
exports["default"] = _default;

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _row["default"];
  }
});
Object.defineProperty(exports, "Col", {
  enumerable: true,
  get: function get() {
    return _col["default"];
  }
});

var _row = _interopRequireDefault(__webpack_require__(432));

var _col = _interopRequireDefault(__webpack_require__(437));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(74));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RowContext = (0, _createReactContext["default"])({});
var _default = RowContext;
exports["default"] = _default;

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _grid = __webpack_require__(424);

var _default = _grid.Col;
exports["default"] = _default;

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(25);

__webpack_require__(429);

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(25);

__webpack_require__(438);

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(25);

__webpack_require__(429);

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = __webpack_require__(136);

var _button2 = _interopRequireDefault(_button);

var _row = __webpack_require__(423);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(427);

var _col2 = _interopRequireDefault(_col);

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  padding-top: 100px;\n  text-align: left;\n  background: url(', ') no-repeat;\n  background-size: cover;\n  background-position-x: right;\n  background-position-y: 100%;\n  color: white;\n  @media only screen and (max-width: ', ') {\n    background: url(', ') no-repeat;\n    margin-bottom: 230px;\n    padding-bottom: 100px;\n  }\n'], ['\n  position: relative;\n  padding-top: 100px;\n  text-align: left;\n  background: url(', ') no-repeat;\n  background-size: cover;\n  background-position-x: right;\n  background-position-y: 100%;\n  color: white;\n  @media only screen and (max-width: ', ') {\n    background: url(', ') no-repeat;\n    margin-bottom: 230px;\n    padding-bottom: 100px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  max-width: 1200px;\n  height: 100%;\n  margin: 0 auto;\n  padding-left: 40px;\n  padding-right: 40px;\n  padding-bottom: 70px;\n'], ['\n  max-width: 1200px;\n  height: 100%;\n  margin: 0 auto;\n  padding-left: 40px;\n  padding-right: 40px;\n  padding-bottom: 70px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n'], ['\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, -30%);\n'], ['\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, -30%);\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: 13px;\n  font-weight: bold;\n  margin-top: 60px;\n  @media only screen and (max-width: ', ') {\n    margin-top: 0;\n  }\n'], ['\n  font-size: 13px;\n  font-weight: bold;\n  margin-top: 60px;\n  @media only screen and (max-width: ', ') {\n    margin-top: 0;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  font-size: 42px;\n  font-weight: bolder;\n  color: white;\n  margin-top: 15px;\n  line-height: 1.2em;\n  margin: 30px auto 40px;\n  @media only screen and (max-width: ', ') {\n    font-size: 36px;\n  }\n'], ['\n  font-size: 42px;\n  font-weight: bolder;\n  color: white;\n  margin-top: 15px;\n  line-height: 1.2em;\n  margin: 30px auto 40px;\n  @media only screen and (max-width: ', ') {\n    font-size: 36px;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  color: ', ';\n  padding: 0 30px;\n  font-size: 14px;\n  :hover {\n    color: ', ';\n  }\n'], ['\n  color: ', ';\n  padding: 0 30px;\n  font-size: 14px;\n  :hover {\n    color: ', ';\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n'], ['\n  display: flex;\n  align-items: center;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  height: 14px;\n  margin-right: 15px;\n'], ['\n  height: 14px;\n  margin-right: 15px;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  margin-top: 25px;\n  font-weight: lighter;\n  font-size: 13px;\n  color: white;\n  display: block;\n  :hover {\n    color: white;\n  }\n'], ['\n  margin-top: 25px;\n  font-weight: lighter;\n  font-size: 13px;\n  color: white;\n  display: block;\n  :hover {\n    color: white;\n  }\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  @media only screen and (max-width: ', ') {\n    position: absolute;\n    top: 40px;\n  }\n'], ['\n  @media only screen and (max-width: ', ') {\n    position: absolute;\n    top: 40px;\n  }\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  background: #FD8129;\n  border-radius: 50%;\n  height: 60px;\n  width: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  background: #FD8129;\n  border-radius: 50%;\n  height: 60px;\n  width: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  height: 20px;\n'], ['\n  height: 20px;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n  text-align: center;\n  font-size: 12px;\n  font-size: 12px;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  :hover {\n    color: inherit;\n  }\n  @media only screen and (max-width: ', ') {\n    display: none;\n  }\n'], ['\n  text-align: center;\n  font-size: 12px;\n  font-size: 12px;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  :hover {\n    color: inherit;\n  }\n  @media only screen and (max-width: ', ') {\n    display: none;\n  }\n']);

__webpack_require__(137);

__webpack_require__(428);

__webpack_require__(430);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactResponsive = __webpack_require__(140);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _styledComponents = __webpack_require__(133);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _I18N = __webpack_require__(135);

var _I18N2 = _interopRequireDefault(_I18N);

var _variable = __webpack_require__(134);

var _images = __webpack_require__(73);

var _images2 = _interopRequireDefault(_images);

var _color = __webpack_require__(138);

var colors = _interopRequireWildcard(_color);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// import './style.less'
exports.default = function () {
  return _react2.default.createElement(
    Container,
    { id: 'hero' },
    _react2.default.createElement(
      ContainerInner,
      null,
      _react2.default.createElement(
        StyledRow,
        null,
        _react2.default.createElement(
          _col2.default,
          { xs: 24, sm: 14 },
          _react2.default.createElement(
            SubTitle,
            null,
            _I18N2.default.get('hero.welcome')
          ),
          _react2.default.createElement(
            Title,
            null,
            _I18N2.default.get('hero.title')
          ),
          _react2.default.createElement(
            StyledButton,
            { shape: 'round', href: '#footer' },
            _react2.default.createElement(
              ButtonInner,
              null,
              _react2.default.createElement(StyledIcon, { src: _images2.default.logo_img, alt: 'icon' }),
              _I18N2.default.get('hero.btnText')
            )
          ),
          _react2.default.createElement(
            Help,
            { href: _I18N2.default.get('footer.store.ios.helpLink'), target: '_blank', rel: 'noopener noreferrer' },
            _I18N2.default.get('hero.help')
          )
        ),
        _react2.default.createElement(
          _col2.default,
          { xs: 24, sm: 10 },
          _react2.default.createElement(
            _reactResponsive2.default,
            { maxWidth: _variable.breakPoint.mobile },
            _react2.default.createElement(WalletImg, { mobile: true, src: _images2.default.hero_phone_image_mobile_img, alt: 'wallet image' })
          ),
          _react2.default.createElement(
            _reactResponsive2.default,
            { minWidth: _variable.breakPoint.mobile },
            _react2.default.createElement(WalletImg, { src: _images2.default.hero_phone_image_img, alt: 'wallet image' })
          )
        )
      ),
      _react2.default.createElement(
        BottomRow,
        null,
        _react2.default.createElement(
          LearnMore,
          { href: '#intro' },
          _react2.default.createElement(
            'div',
            null,
            _I18N2.default.get('hero.learnMore')
          ),
          _react2.default.createElement(
            Circle,
            null,
            _react2.default.createElement(DownArrow, { src: _images2.default.down_arrow_img, alt: 'down arrow' })
          )
        )
      )
    )
  );
};

var Container = _styledComponents2.default.div(_templateObject, _images2.default.top_background_img, _variable.breakPoint.mobile, _images2.default.top_background_mobile_img);
var ContainerInner = _styledComponents2.default.div(_templateObject2);
var StyledRow = (0, _styledComponents2.default)(_row2.default)(_templateObject3);
var BottomRow = (0, _styledComponents2.default)(_row2.default)(_templateObject4);
var SubTitle = _styledComponents2.default.div(_templateObject5, _variable.breakPoint.mobile);
var Title = _styledComponents2.default.h1(_templateObject6, _variable.breakPoint.mobile);
var StyledButton = (0, _styledComponents2.default)(_button2.default)(_templateObject7, colors.text.theme, colors.text.theme);
var ButtonInner = _styledComponents2.default.div(_templateObject8);
var StyledIcon = _styledComponents2.default.img(_templateObject9);
var Help = _styledComponents2.default.a(_templateObject10);
var WalletImg = _styledComponents2.default.img(_templateObject11, _variable.breakPoint.mobile);
var Circle = _styledComponents2.default.div(_templateObject12);
var DownArrow = _styledComponents2.default.img(_templateObject13);
var LearnMore = _styledComponents2.default.a(_templateObject14, _variable.breakPoint.mobile);

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _configProvider = __webpack_require__(9);

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _RowContext = _interopRequireDefault(__webpack_require__(425));

var _type = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
var enquire;

if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  };

  window.matchMedia = window.matchMedia || matchMediaPolyfill;
  enquire = __webpack_require__(433);
}

var RowAligns = (0, _type.tuple)('top', 'middle', 'bottom');
var RowJustify = (0, _type.tuple)('start', 'end', 'center', 'space-around', 'space-between');
var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
var responsiveMap = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)'
};

var Row =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Row, _React$Component);

  function Row() {
    var _this;

    _classCallCheck(this, Row);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Row).apply(this, arguments));
    _this.state = {
      screens: {}
    };

    _this.renderRow = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          justify = _a.justify,
          align = _a.align,
          className = _a.className,
          style = _a.style,
          children = _a.children,
          others = __rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);

      var prefixCls = getPrefixCls('row', customizePrefixCls);

      var gutter = _this.getGutter();

      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, !type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(justify), type && justify), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(align), type && align), _classNames), className);
      var rowStyle = gutter > 0 ? _extends({
        marginLeft: gutter / -2,
        marginRight: gutter / -2
      }, style) : style;

      var otherProps = _extends({}, others);

      delete otherProps.gutter;
      return React.createElement(_RowContext["default"].Provider, {
        value: {
          gutter: gutter
        }
      }, React.createElement("div", _extends({}, otherProps, {
        className: classes,
        style: rowStyle
      }), children));
    };

    return _this;
  }

  _createClass(Row, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      Object.keys(responsiveMap).map(function (screen) {
        return enquire.register(responsiveMap[screen], {
          match: function match() {
            if (_typeof(_this2.props.gutter) !== 'object') {
              return;
            }

            _this2.setState(function (prevState) {
              return {
                screens: _extends({}, prevState.screens, _defineProperty({}, screen, true))
              };
            });
          },
          unmatch: function unmatch() {
            if (_typeof(_this2.props.gutter) !== 'object') {
              return;
            }

            _this2.setState(function (prevState) {
              return {
                screens: _extends({}, prevState.screens, _defineProperty({}, screen, false))
              };
            });
          },
          // Keep a empty destory to avoid triggering unmatch when unregister
          destroy: function destroy() {}
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Object.keys(responsiveMap).map(function (screen) {
        return enquire.unregister(responsiveMap[screen]);
      });
    }
  }, {
    key: "getGutter",
    value: function getGutter() {
      var gutter = this.props.gutter;

      if (_typeof(gutter) === 'object') {
        for (var i = 0; i < responsiveArray.length; i++) {
          var breakpoint = responsiveArray[i];

          if (this.state.screens[breakpoint] && gutter[breakpoint] !== undefined) {
            return gutter[breakpoint];
          }
        }
      }

      return gutter;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderRow);
    }
  }]);

  return Row;
}(React.Component);

exports["default"] = Row;
Row.defaultProps = {
  gutter: 0
};
Row.propTypes = {
  type: PropTypes.oneOf(['flex']),
  align: PropTypes.oneOf(RowAligns),
  justify: PropTypes.oneOf(RowJustify),
  className: PropTypes.string,
  children: PropTypes.node,
  gutter: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  prefixCls: PropTypes.string
};

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(434);
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(435);
var Util = __webpack_require__(426);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(436);
var each = __webpack_require__(426).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ 436:
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _RowContext = _interopRequireDefault(__webpack_require__(425));

var _configProvider = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var objectOrNumber = PropTypes.oneOfType([PropTypes.object, PropTypes.number]);

var Col =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Col, _React$Component);

  function Col() {
    var _this;

    _classCallCheck(this, Col);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Col).apply(this, arguments));

    _this.renderCol = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var props = _this.props;

      var customizePrefixCls = props.prefixCls,
          span = props.span,
          order = props.order,
          offset = props.offset,
          push = props.push,
          pull = props.pull,
          className = props.className,
          children = props.children,
          others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);

      var prefixCls = getPrefixCls('col', customizePrefixCls);
      var sizeClassObj = {};
      ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
        var _extends2;

        var sizeProps = {};

        if (typeof props[size] === 'number') {
          sizeProps.span = props[size];
        } else if (_typeof(props[size]) === 'object') {
          sizeProps = props[size] || {};
        }

        delete others[size];
        sizeClassObj = _extends({}, sizeClassObj, (_extends2 = {}, _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _extends2));
      });
      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), _defineProperty(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
      return React.createElement(_RowContext["default"].Consumer, null, function (_ref2) {
        var gutter = _ref2.gutter;
        var style = others.style;

        if (gutter > 0) {
          style = _extends({
            paddingLeft: gutter / 2,
            paddingRight: gutter / 2
          }, style);
        }

        return React.createElement("div", _extends({}, others, {
          style: style,
          className: classes
        }), children);
      });
    };

    return _this;
  }

  _createClass(Col, [{
    key: "render",
    value: function render() {
      return React.createElement(_configProvider.ConfigConsumer, null, this.renderCol);
    }
  }]);

  return Col;
}(React.Component);

exports["default"] = Col;
Col.propTypes = {
  span: PropTypes.number,
  order: PropTypes.number,
  offset: PropTypes.number,
  push: PropTypes.number,
  pull: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
  xs: objectOrNumber,
  sm: objectOrNumber,
  md: objectOrNumber,
  lg: objectOrNumber,
  xl: objectOrNumber,
  xxl: objectOrNumber
};

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = __webpack_require__(136);

var _button2 = _interopRequireDefault(_button);

var _row = __webpack_require__(423);

var _row2 = _interopRequireDefault(_row);

var _col = __webpack_require__(427);

var _col2 = _interopRequireDefault(_col);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  background-color: white;\n  color: ', ';\n  @media only screen and (max-width: ', ') {\n    overflow: hidden;\n  }\n'], ['\n  position: relative;\n  background-color: white;\n  color: ', ';\n  @media only screen and (max-width: ', ') {\n    overflow: hidden;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  /* max-width: 1200px;\n  margin: 0 auto; */\n  height: 100%;\n  padding-left: 40px;\n  padding-right: 40px;\n  max-width: 960px;\n  margin: 40px auto;\n  '], ['\n  /* max-width: 1200px;\n  margin: 0 auto; */\n  height: 100%;\n  padding-left: 40px;\n  padding-right: 40px;\n  max-width: 960px;\n  margin: 40px auto;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  text-align: left;\n  margin-bottom: 30px;\n  /* @media only screen and (min-width: ', ') {\n    background: url(', ') no-repeat;\n  } */\n  /* did_white_box_img\n  multi_white_box_img\n  open_white_box_img\n  telegram_white_box_img}) */\n'], ['\n  text-align: left;\n  margin-bottom: 30px;\n  /* @media only screen and (min-width: ', ') {\n    background: url(', ') no-repeat;\n  } */\n  /* did_white_box_img\n  multi_white_box_img\n  open_white_box_img\n  telegram_white_box_img}) */\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 24px;\n  /* @media only screen and (max-width: ', ') {\n  } */\n'], ['\n  color: ', ';\n  font-size: 24px;\n  /* @media only screen and (max-width: ', ') {\n  } */\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: 14px;\n'], ['\n  font-size: 14px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  padding-top: 40px;\n  margin-top: 40px;\n  border-top: 1px solid ', ';\n'], ['\n  padding-top: 40px;\n  margin-top: 40px;\n  border-top: 1px solid ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  text-align: center;\n  margin-bottom: 30px;\n'], ['\n  text-align: center;\n  margin-bottom: 30px;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  height: 100px;\n'], ['\n  height: 100px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 16px;\n  margin: 15px auto;\n'], ['\n  color: ', ';\n  font-size: 16px;\n  margin: 15px auto;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  line-height: 1.5em;\n'], ['\n  font-size: 14px;\n  line-height: 1.5em;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  margin-top: 20px;\n'], ['\n  margin-top: 20px;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  border: none;\n  background-color: ', ';\n  color: white;\n  font-weight: 14px;\n  padding: 0 20px;\n  :hover {\n    background-color: ', ';\n    color: white;\n  }\n'], ['\n  border: none;\n  background-color: ', ';\n  color: white;\n  font-weight: 14px;\n  padding: 0 20px;\n  :hover {\n    background-color: ', ';\n    color: white;\n  }\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  height: 16px;\n  margin-right: 10px;\n'], ['\n  height: 16px;\n  margin-right: 10px;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n\n'], ['\n\n']);

__webpack_require__(137);

__webpack_require__(428);

__webpack_require__(430);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(133);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _I18N = __webpack_require__(135);

var _I18N2 = _interopRequireDefault(_I18N);

var _variable = __webpack_require__(134);

var _images = __webpack_require__(73);

var _images2 = _interopRequireDefault(_images);

var _color = __webpack_require__(138);

var colors = _interopRequireWildcard(_color);

var _footer = __webpack_require__(440);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));

    _this.state = {};
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          Container,
          { id: 'intro' },
          _react2.default.createElement(
            ContainerInner,
            null,
            _react2.default.createElement(
              StyledRow,
              { gutter: 24 },
              _react2.default.createElement(
                _col2.default,
                { xs: 24, sm: { span: 6, offset: 2 } },
                _react2.default.createElement(
                  Title,
                  null,
                  _I18N2.default.get('intro.about.title')
                )
              ),
              _react2.default.createElement(
                _col2.default,
                { xs: 24, sm: 16 },
                _react2.default.createElement(
                  Desc,
                  null,
                  _I18N2.default.get('intro.about.desc')
                )
              )
            ),
            _react2.default.createElement(
              StyledRow,
              { gutter: 24 },
              _react2.default.createElement(
                _col2.default,
                { xs: 24, sm: { span: 6, offset: 2 } },
                _react2.default.createElement(
                  Title,
                  null,
                  _I18N2.default.get('intro.social.telegram.title')
                )
              ),
              _react2.default.createElement(
                _col2.default,
                { xs: 24, sm: 16 },
                _react2.default.createElement(
                  Desc,
                  null,
                  _I18N2.default.get('intro.social.telegram.desc')
                ),
                _react2.default.createElement(
                  BtnContainer,
                  null,
                  _react2.default.createElement(
                    SocialButton,
                    { href: _I18N2.default.get('links.telegram'), shape: 'round', target: '_blank', rel: 'noopener noreferrer' },
                    _react2.default.createElement(BtnImg, { src: _images2.default.telegram_icon_img, className: 'spacer', alt: 'download url' }),
                    _react2.default.createElement(
                      BtnText,
                      null,
                      _I18N2.default.get('intro.social.telegram.btnText')
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              FeatureRow,
              { gutter: 24 },
              _react2.default.createElement(
                FeatureItem,
                { xs: 24, sm: 8 },
                _react2.default.createElement(FeatureImg, { src: _images2.default.did_icon_img, className: 'spacer', alt: 'download url' }),
                _react2.default.createElement(
                  FeatureTitle,
                  null,
                  _I18N2.default.get('intro.feature.feature_1.title')
                ),
                _react2.default.createElement(
                  FeatureDesc,
                  null,
                  _I18N2.default.get('intro.feature.feature_1.desc')
                )
              ),
              _react2.default.createElement(
                FeatureItem,
                { xs: 24, sm: 8 },
                _react2.default.createElement(FeatureImg, { src: _images2.default.multi_icon_img, className: 'spacer', alt: 'download url' }),
                _react2.default.createElement(
                  FeatureTitle,
                  null,
                  _I18N2.default.get('intro.feature.feature_2.title')
                ),
                _react2.default.createElement(
                  FeatureDesc,
                  null,
                  _I18N2.default.get('intro.feature.feature_2.desc')
                )
              ),
              _react2.default.createElement(
                FeatureItem,
                { xs: 24, sm: 8 },
                _react2.default.createElement(FeatureImg, { src: _images2.default.opensource_icon_img, className: 'spacer', alt: 'download url' }),
                _react2.default.createElement(
                  FeatureTitle,
                  null,
                  _I18N2.default.get('intro.feature.feature_3.title')
                ),
                _react2.default.createElement(
                  FeatureDesc,
                  null,
                  _I18N2.default.get('intro.feature.feature_3.desc')
                )
              )
            )
          )
        ),
        _react2.default.createElement(_footer2.default, null)
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

exports.default = _class;

var Container = _styledComponents2.default.div(_templateObject, colors.text.theme, _variable.breakPoint.mobile);
var ContainerInner = _styledComponents2.default.div(_templateObject2);
var StyledRow = (0, _styledComponents2.default)(_row2.default)(_templateObject3, _variable.breakPoint.mobile, _images2.default.about_white_box_img);
var Title = _styledComponents2.default.h2(_templateObject4, colors.text.theme, _variable.breakPoint.mobile);
var Desc = _styledComponents2.default.div(_templateObject5);
var FeatureRow = (0, _styledComponents2.default)(_row2.default)(_templateObject6, colors.border.theme);
var FeatureItem = (0, _styledComponents2.default)(_col2.default)(_templateObject7);
var FeatureImg = _styledComponents2.default.img(_templateObject8);
var FeatureTitle = _styledComponents2.default.h3(_templateObject9, colors.text.theme);
var FeatureDesc = _styledComponents2.default.div(_templateObject10);
var BtnContainer = _styledComponents2.default.div(_templateObject11);
var SocialButton = (0, _styledComponents2.default)(_button2.default)(_templateObject12, colors.bg.theme, colors.bg.theme);
var BtnImg = _styledComponents2.default.img(_templateObject13);
var BtnText = _styledComponents2.default.span(_templateObject14);

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  text-align: center;\n  background: url(', ') no-repeat;\n  background-size: cover;\n  color: white;\n  @media only screen and (max-width: ', ') {\n    background: url(', ') no-repeat;\n    /* margin-bottom: 200px;\n    padding-bottom: 100px; */\n  }\n'], ['\n  position: relative;\n  text-align: center;\n  background: url(', ') no-repeat;\n  background-size: cover;\n  color: white;\n  @media only screen and (max-width: ', ') {\n    background: url(', ') no-repeat;\n    /* margin-bottom: 200px;\n    padding-bottom: 100px; */\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  max-width: 1200px;\n  height: 100%;\n  margin: 0 auto;\n  padding: 40px;\n'], ['\n  max-width: 1200px;\n  height: 100%;\n  margin: 0 auto;\n  padding: 40px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  text-align: center;\n  /* position: absolute;\n  left: calc(50% - 40px);\n  top: -40px; */\n'], ['\n  text-align: center;\n  /* position: absolute;\n  left: calc(50% - 40px);\n  top: -40px; */\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  height: 80px;\n'], ['\n  height: 80px;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(133);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _wallet = __webpack_require__(441);

var _wallet2 = _interopRequireDefault(_wallet);

var _bottom = __webpack_require__(442);

var _bottom2 = _interopRequireDefault(_bottom);

var _variable = __webpack_require__(134);

var _images = __webpack_require__(73);

var _images2 = _interopRequireDefault(_images);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import I18N from '../../I18N'


var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        Container,
        { id: 'footer' },
        _react2.default.createElement(
          Inner,
          { id: 'footer-inner' },
          _react2.default.createElement(
            LogoContainer,
            null,
            _react2.default.createElement(Logo, { src: _images2.default.elephant_circle_logo_img, className: 'footer-logo', alt: 'logo' })
          ),
          _react2.default.createElement(_wallet2.default, null),
          _react2.default.createElement(_bottom2.default, null)
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

exports.default = _class;

var Container = _styledComponents2.default.div(_templateObject, _images2.default.bottom_background_img, _variable.breakPoint.mobile, _images2.default.bottom_background_mobile_img);
var Inner = _styledComponents2.default.div(_templateObject2);
var LogoContainer = _styledComponents2.default.div(_templateObject3);
var Logo = _styledComponents2.default.img(_templateObject4);

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(34);

var _icon2 = _interopRequireDefault(_icon);

var _button = __webpack_require__(136);

var _button2 = _interopRequireDefault(_button);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  max-width: 450px;\n  margin: 30px auto;\n'], ['\n  max-width: 450px;\n  margin: 30px auto;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 32px;\n  font-weight: 400;\n  color: white;\n  @media only screen and (max-width: ', ') {\n    font-size: 20px;\n  }\n'], ['\n  font-size: 32px;\n  font-weight: 400;\n  color: white;\n  @media only screen and (max-width: ', ') {\n    font-size: 20px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  height: 4rem;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  @media only screen and (max-width: ', ') {\n    height: auto;\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n'], ['\n  height: 4rem;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  @media only screen and (max-width: ', ') {\n    height: auto;\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  height: 70px;\n'], ['\n  height: 70px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  color: ', ';\n  border: none;\n  :hover {\n    color: ', ';\n  }\n  @media only screen and (max-width: ', ') {\n    margin-bottom: 20px;\n  }\n'], ['\n  font-size: 14px;\n  color: ', ';\n  border: none;\n  :hover {\n    color: ', ';\n  }\n  @media only screen and (max-width: ', ') {\n    margin-bottom: 20px;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n'], ['\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  font-size: 14px;\n  @media only screen and (max-width: ', ') {\n    flex-direction: column;\n  }\n'], ['\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  font-size: 14px;\n  @media only screen and (max-width: ', ') {\n    flex-direction: column;\n  }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  flex: 200px 0 0;\n  margin-bottom: 20px;\n'], ['\n  flex: 200px 0 0;\n  margin-bottom: 20px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  color: white;\n  padding-top: 30px;\n  border-top: 1px solid white;\n'], ['\n  font-size: 16px;\n  color: white;\n  padding-top: 30px;\n  border-top: 1px solid white;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  margin-bottom: 10px;\n'], ['\n  margin-bottom: 10px;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  height: 200px;\n'], ['\n  height: 200px;\n']);

__webpack_require__(141);

__webpack_require__(137);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(133);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _I18N = __webpack_require__(135);

var _I18N2 = _interopRequireDefault(_I18N);

var _variable = __webpack_require__(134);

var _color = __webpack_require__(138);

var colors = _interopRequireWildcard(_color);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        Container,
        null,
        _react2.default.createElement(
          Title,
          null,
          _I18N2.default.get('footer.title')
        ),
        _react2.default.createElement(
          'div',
          null,
          _I18N2.default.get('footer.store.title')
        ),
        _react2.default.createElement(
          List,
          null,
          _react2.default.createElement(
            ListItem,
            null,
            _react2.default.createElement(
              'a',
              { href: _I18N2.default.get('footer.store.ios.storeLink'), target: '_blank', rel: 'noopener noreferrer' },
              _react2.default.createElement(StoreImg, { src: _I18N2.default.get('footer.store.ios.storeImg'), className: 'spacer', alt: 'download url' })
            ),
            _react2.default.createElement(
              Help,
              null,
              _I18N2.default.get('footer.store.ios.help')
            ),
            _react2.default.createElement(
              StyledButton,
              { shape: 'round', href: _I18N2.default.get('footer.store.ios.helpLink'), target: '_blank', rel: 'noopener noreferrer' },
              _react2.default.createElement(StyledIcon, { type: 'apple', theme: 'filled' }),
              _I18N2.default.get('footer.store.ios.btnText')
            )
          ),
          _react2.default.createElement(
            ListItem,
            null,
            _react2.default.createElement(
              'a',
              { href: _I18N2.default.get('footer.store.android.storeLink'), target: '_blank', rel: 'noopener noreferrer' },
              _react2.default.createElement(StoreImg, { src: _I18N2.default.get('footer.store.android.storeImg'), className: 'spacer', alt: 'download url' })
            ),
            _react2.default.createElement(
              Help,
              null,
              _I18N2.default.get('footer.store.android.help')
            ),
            _react2.default.createElement(
              StyledButton,
              { shape: 'round', href: _I18N2.default.get('footer.store.android.helpLink'), target: '_blank' },
              _react2.default.createElement(StyledIcon, { type: 'android', theme: 'filled' }),
              _I18N2.default.get('footer.store.android.btnText')
            )
          )
        ),
        _react2.default.createElement(
          QRTitle,
          null,
          _I18N2.default.get('footer.qrCode.title')
        ),
        _react2.default.createElement(
          List,
          null,
          _react2.default.createElement(
            ListItem,
            null,
            _react2.default.createElement(
              ImgTitle,
              null,
              _I18N2.default.get('footer.qrCode.ios.title')
            ),
            _react2.default.createElement(QRImg, { src: _I18N2.default.get('footer.qrCode.ios.url'), className: 'spacer', alt: 'wallet' })
          ),
          _react2.default.createElement(
            ListItem,
            null,
            _react2.default.createElement(
              ImgTitle,
              null,
              _I18N2.default.get('footer.qrCode.android.title')
            ),
            _react2.default.createElement(QRImg, { src: _I18N2.default.get('footer.qrCode.android.url'), className: 'spacer', alt: 'wallet' })
          )
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

exports.default = _class;

var Container = _styledComponents2.default.div(_templateObject);
var Title = _styledComponents2.default.h2(_templateObject2, _variable.breakPoint.mobile);
var Help = _styledComponents2.default.div(_templateObject3, _variable.breakPoint.mobile);
var StoreImg = _styledComponents2.default.img(_templateObject4);
var StyledButton = (0, _styledComponents2.default)(_button2.default)(_templateObject5, colors.text.theme, colors.text.theme, _variable.breakPoint.mobile);
var StyledIcon = (0, _styledComponents2.default)(_icon2.default)(_templateObject6);
var List = _styledComponents2.default.div(_templateObject7, _variable.breakPoint.mobile);
var ListItem = _styledComponents2.default.div(_templateObject8);
var QRTitle = _styledComponents2.default.h4(_templateObject9);
var ImgTitle = _styledComponents2.default.div(_templateObject10);
var QRImg = _styledComponents2.default.img(_templateObject11);

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 30px;\n  border-top: 1px solid white;\n  color: white;\n  padding-top: 20px;\n'], ['\n  margin-top: 30px;\n  border-top: 1px solid white;\n  color: white;\n  padding-top: 20px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: white;\n'], ['\n  color: white;\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(133);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _I18N = __webpack_require__(135);

var _I18N2 = _interopRequireDefault(_I18N);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import { breakPoint } from '../../constants/variable'
// import * as colors from '../../constants/color'
var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        Container,
        null,
        _react2.default.createElement(
          Link,
          { href: _I18N2.default.get('footer.privacyPolicy.link'), rel: 'noopener noreferrer' },
          _I18N2.default.get('footer.privacyPolicy.title')
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

exports.default = _class;

var Container = _styledComponents2.default.div(_templateObject);
var Link = _styledComponents2.default.a(_templateObject2);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/home.5fb7769e.js